/* eslint-disable react-hooks/exhaustive-deps */
"use client";
import { useIsMobile } from "@/hooks/useIsMobile";
import {
  CalendarStyle,
  ICalendar,
} from "@/api/AppApi/services/home/interfaces/ICalendar";
import { useProductHasAttrs } from "@/hooks/product-has-attrs/useProductHasAttrs";
import Separator from "../../lib/Separator";
import Attributes from "../../pages-components/product-details-page/details-belpers/product-attributes/Attributes";
import AddOns from "../../pages-components/product-details-page/details-belpers/product-addons/AddOns";
import { useForm } from "react-hook-form";
import { IField } from "@/api/AppApi/services/builder/interfaces/interfaces";
import {
  defaultValues,
  renameFields,
} from "../../common-form-builder/form-builder-helpers/form-functions";
import CommonFormBuilder from "../../common-form-builder/CommonFormBuilder";
import SpecificProduct from "../../pages-components/product-details-page/details-belpers/specific-product/SpecificProduct";
import { ProductPreviewTypes } from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { IsTopWinner } from "@/utils/functions/global-constants";
import { useEffect, useState } from "react";

interface Props extends ICalendar {}

const CalendarService: React.FC<Props> = (props) => {
  const company = useGetCompanyQuery();
  const isTopWinner = IsTopWinner(company?.data?.result!);
  const {
    auto_select_first_child_in_show_product: autoSelectFirstChild,
    show_calender_as_popup,
  } = company?.data?.result?.theme?.components?.product ?? {};

  const product = props.data;
  const form = useForm<any>();
  const [fields, setFields] = useState<Array<IField>>([]);
  const fieldsBuilder = product?.fields_builder;
  const productState = useProductHasAttrs(product!);
  const { currentProd, otherInputs } = productState;
  const mobile = useIsMobile();
  const beside = props.configurations.style_type === CalendarStyle.beside;
  const cn = beside ? "-beside" : "-inside";
  useEffect(() => {
    if (!productState) return;
    const getKey = (str: string) => {
      const string = str.split(".");
      return string[string.length - 1];
    };
    const initFields = new Array<IField>();
    fieldsBuilder?.forEach((field) => {
      initFields?.push({
        ...field,
        value: otherInputs?.[getKey(field?.configurations?.key)],
      });
    });
    const fields = renameFields(initFields);
    form.reset(defaultValues(fields));
    setFields(fields!);
  }, [otherInputs, currentProd]);
  const mClass = mobile ? "-mobile" : "";
  let specificProdCn = mobile ? "" : `pc-calendar${cn}`;
  let containerClassName = "";
  if (currentProd.preview_type === ProductPreviewTypes.consultation) {
    containerClassName = `consutation${mClass} in-builder`;
    specificProdCn = "consult-details";
  }
  useEffect(() => {
    isTopWinner && productState.setSelectedChildIndex(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div
      //id to scroll to clandar from slider
      id="calendar"
      className={!mobile ? "pc-calendar-service-container" : ""}
      style={
        !mobile
          ? {
              backgroundSize: "cover",
              backgroundImage: `url('${props.configurations.background_image}')`,
              backgroundRepeat: "no-repeat, no-repeat",
              backgroundPosition: "center center",
            }
          : {}
      }
    >
      {mobile ? (
        <Separator startLabel={props.configurations.title} />
      ) : (
        <div className="title">{props.configurations.title}</div>
      )}
      <div
        className={mobile ? "mobile-clalendar-service" : "pc-calendar-service"}
      >
        <div className="calendar-service-attrs">
          {fields?.length > 0 &&
            fields?.map((field) => (
              <div key={field?.configurations?.key}>
                <Separator
                  marginBottom={8}
                  startLabel={field?.configurations?.title}
                />
                <CommonFormBuilder field={field} form={form} />
              </div>
            ))}
          {product?.attributes_builder?.length > 0 && (
            <Attributes
              isTopWinner={isTopWinner}
              product={product}
              setSelectedChildIndex={productState.setSelectedChildIndex}
              initialValues={
                isTopWinner ? product.children[0].attribute_ids : undefined
              }
              autoSelectFirstChild={autoSelectFirstChild!}
            />
          )}
          {currentProd?.addons_builder?.length > 0 && (
            <AddOns
              addOnBiulder={currentProd.addons_builder}
              state={productState.selectedAddOns}
              setState={productState.handleSelectedAddOnsChanged}
            />
          )}
          <div className="consult-section-body">
            {currentProd.description ?? product.description}
          </div>
        </div>
        <div className={containerClassName}>
          <div className={specificProdCn}>
            <SpecificProduct
              productState={productState!}
              isPopupMobile={false}
              form={form}
              beside={props.configurations.style_type === CalendarStyle.beside}
              showCalenderAsPopup={show_calender_as_popup}
            />
          </div>
        </div>

        {/* <div className={mobile ? "" : `pc-calendar${cn}`}>
          {productState.cartDisabled ? (
            <CalendarNotAvailable form={form} productState={productState} />
          ) : (
            <Calendar form={form} beside={beside} />
          )}
        </div> */}
      </div>
    </div>
  );
};

export default CalendarService;
